import { defineMessages } from 'react-intl';

// Copy for the pricing-status timeline shown on the service edit pages once a
// retail-rate-request exists (IOPS-5494). Rejection-reason strings are keyed off
// RetailRateRequestStatusReason.
export const messages = defineMessages({
  // Compact status label (with a colored dot) summarising the request.
  statusPendingReview: {
    id: 'manage-services.pricing-status.status-pending-review',
    defaultMessage: 'Pending review',
  },
  statusAvailable: {
    id: 'manage-services.pricing-status.status-available',
    defaultMessage: 'Available',
  },
  statusAvailableWithChanges: {
    id: 'manage-services.pricing-status.status-available-with-changes',
    defaultMessage: 'Available with changes',
  },
  statusVerificationFailed: {
    id: 'manage-services.pricing-status.status-verification-failed',
    defaultMessage: 'Verification failed',
  },

  // Timeline steps.
  stepSubmittedTitle: {
    id: 'manage-services.pricing-status.step-submitted-title',
    defaultMessage: 'Service submitted',
  },
  stepVerificationTitle: {
    id: 'manage-services.pricing-status.step-verification-title',
    defaultMessage: 'Pending price verification',
  },
  stepVerificationSubtitle: {
    id: 'manage-services.pricing-status.step-verification-subtitle',
    defaultMessage: 'Our team is reviewing the proof of pricing provided. This usually takes 1-2 business days.',
  },
  stepApprovedTitle: {
    id: 'manage-services.pricing-status.step-approved-title',
    defaultMessage: 'Approved',
  },
  stepApprovedSubtitle: {
    id: 'manage-services.pricing-status.step-approved-subtitle',
    defaultMessage: 'Approved and available for ClassPass users to book.',
  },
  stepApprovedRateChangeSubtitle: {
    id: 'manage-services.pricing-status.step-approved-rate-change-subtitle',
    defaultMessage: 'Approved with a rate change. The updated rate is now available on ClassPass.',
  },
  stepFailedTitle: {
    id: 'manage-services.pricing-status.step-failed-title',
    defaultMessage: 'Verification failed',
  },

  // Rejection reasons (shown on the failed step).
  reasonProofUntrusted: {
    id: 'manage-services.pricing-status.reason-proof-untrusted',
    defaultMessage:
      "We're unable to approve this request as the pricing proof provided could not be verified. If you believe this is a mistake, please contact support.",
  },
  reasonPartnerDeclined: {
    id: 'manage-services.pricing-status.reason-partner-declined',
    defaultMessage: 'Pricing submission was declined.',
  },
  reasonGenreDisallowed: {
    id: 'manage-services.pricing-status.reason-genre-disallowed',
    defaultMessage: 'Genre not approved for ClassPass.',
  },
  reasonPartnerDisagreement: {
    id: 'manage-services.pricing-status.reason-partner-disagreement',
    defaultMessage: 'Disagreement on pricing terms.',
  },
  reasonGeneric: {
    id: 'manage-services.pricing-status.reason-generic',
    defaultMessage: 'We were unable to verify this pricing request. Please contact support.',
  },
});
